import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Component({
  selector: 'app-ao-transparency-toggle',
  templateUrl: './ao-transparency-toggle.component.html',
  styleUrls: ['./ao-transparency-toggle.component.scss'],
  standalone: false
})
export class AOTransparencyToggleComponent implements OnDestroy {
  @Output() showInfoHandler = new EventEmitter<any>();
  protected readonly onDestroy$ = new Subject<void>();
  active = false;
  appLocation = 'ch';

  constructor(private store: Store) {
    this.store
      .pipe(select(fromAppRoot.selectCustomer))
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.appLocation = value.app_location;
      });
  }

  toggleContent(): void {
    this.active = !this.active;
    this.showInfoHandler.emit();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
